/* Gartenzeit Ampelschirm-Finder – Logik
   ------------------------------------------------------------------
   Gehoert zu:
     sections/gartenzeit-ampelschirm-finder.liquid  (Markup + Einstellungen)
     assets/gartenzeit-finder.css                   (Aussehen)
     assets/gartenzeit-finder-catalog.json          (Marken- und Modellliste)
     locales/en.default.json | de.json | fr.json    (ALLE Texte)

   Seit 11.09.2026 stehen saemtliche Texte in den Sprachdateien des Themes
   unter "ampelschirm_finder". Dadurch sind sie in Translate & Adapt
   uebersetzbar, genau wie der restliche Shop-Inhalt. In dieser Datei
   stehen KEINE Texte mehr - sie kommen ueber das Konfigurations-JSON
   aus der Sektion herein.

   Bearbeiten:
     Texte            -> Translate & Adapt, bzw. locales/*.json
     Marken/Modelle   -> assets/gartenzeit-finder-catalog.json
     Kontakt, Gewicht -> Theme-Editor, Einstellungen der Sektion

   Datenstand der Modellliste: 07.09.2026. Keine Herstellerzertifizierung,
   keine Windfreigabe.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var SYMBOLE = { direct: '\u2713', adapter: '+', standpipe: '+', not_direct: '\u00d7', unsuitable: '\u00d7', input: '?', unknown: '?', geometry: '?' };

  function fuellen(vorlage, werte) {
    return String(vorlage == null ? '' : vorlage).replace(/\{(\w+)\}/g, function (treffer, name) {
      return Object.prototype.hasOwnProperty.call(werte, name) ? werte[name] : treffer;
    });
  }

  /* Texte kommen aus den Sprachdateien, uebergeben ueber das Konfig-JSON. */

  var _dec = null;
  function entpacke(wert) {
    if (typeof wert !== 'string' || wert.indexOf('&') === -1) return wert;
    if (!_dec) _dec = document.createElement('textarea');
    _dec.innerHTML = wert;
    return _dec.value;
  }
  function entpackeAlle(obj) {
    var aus = {};
    for (var k in (obj || {})) if (Object.prototype.hasOwnProperty.call(obj, k)) aus[k] = entpacke(obj[k]);
    return aus;
  }
  var TEXTE = {};
  function T(schluessel) {
    return Object.prototype.hasOwnProperty.call(TEXTE, schluessel) ? TEXTE[schluessel] : '';
  }

  /* Modell-Labels sind Produktnamen und bleiben unuebersetzt. Ausnahme: Eintraege
     mit 'labelKey' (z. B. "Alle Modelle"), die aus den Sprachdateien kommen. */
  function labelVon(eintrag) {
    if (!eintrag) return '';
    return (eintrag.labelKey && T(eintrag.labelKey)) || eintrag.label || '';
  }
  function katalogText(cfg, schluessel) {
    if (!schluessel) return '';
    var m = cfg.katalogTexte || {};
    return Object.prototype.hasOwnProperty.call(m, schluessel) ? m[schluessel] : '';
  }
  /* Katalog wird pro URL nur einmal geladen. */
  var katalogCache = {};
  function katalogLaden(url) {
    if (!katalogCache[url]) {
      katalogCache[url] = fetch(url, { credentials: 'omit' })
        .then(function (antwort) {
          if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
          return antwort.json();
        })
        .then(function (daten) {
          if (Array.isArray(daten)) return daten;
          return daten.marken || daten.brands || [];
        });
    }
    return katalogCache[url];
  }

  function millimeter(wert) {
    var bereinigt = String(wert).trim().replace(',', '.');
    if (!/^\d+(?:\.\d+)?$/.test(bereinigt)) return null;
    var zahl = Number(bereinigt);
    return isFinite(zahl) && zahl > 0 ? zahl : null;
  }

  function masseBewerten(werte, lochbilder) {
    var zahlen = werte.map(millimeter);
    var diagonale = zahlen[0], a = zahlen[1], b = zahlen[2];
    if (zahlen.some(function (n) { return n === null; })) {
      return { state: 'input', title: T('mass_fehlend'), text: T('mass_fehlend_text') };
    }
    var treffer = lochbilder.filter(function (p) { return p.diagonale === diagonale && p.seite === a && p.seite === b; })[0];
    if (treffer) {
      return { state: 'geometry', title: T('mass_treffer'), text: fuellen(T('mass_treffer_text'), treffer) };
    }
    return { state: 'unknown', title: T('mass_offen'), text: T('mass_offen_text') };
  }

  function modellBewerten(eintrag, nurRohr, cfg) {
    if (eintrag && eintrag.minBaseKg > cfg.maxKg) {
      return {
        state: 'unsuitable',
        title: T('titel_ungeeignet'),
        text: fuellen(T('text_ungeeignet'), { min: eintrag.minBaseKg, max: cfg.maxKg, stand: cfg.standName })
      };
    }
    if (nurRohr) {
      return { state: 'standpipe', title: T('titel_standrohr'), text: fuellen(T('text_standrohr'), { stand: cfg.standName }) };
    }
    if (!eintrag) {
      return { state: 'input', title: T('titel_start'), text: T('text_start') };
    }
    if (eintrag.status === 'direct' && eintrag.basis && eintrag.scopeKey) {
      return { state: 'direct', title: T('titel_direkt'), text: katalogText(cfg, eintrag.scopeKey) };
    }
    if (eintrag.status === 'adapter' && eintrag.basis && eintrag.adapter && eintrag.adapter.name && eintrag.adapter.url) {
      return { state: 'adapter', title: T('titel_adapter'), text: katalogText(cfg, eintrag.scopeKey), adapter: eintrag.adapter };
    }
    if (eintrag.status === 'not_direct' && eintrag.basis) {
      return { state: 'not_direct', title: T('titel_nicht_direkt'), text: katalogText(cfg, eintrag.scopeKey) };
    }
    if (eintrag.status === 'geometry' && eintrag.basis) {
      return { state: 'geometry', title: T('titel_geometrie'), text: katalogText(cfg, eintrag.scopeKey) };
    }
    if (eintrag.status === 'standpipe' && eintrag.basis) {
      return { state: 'standpipe', title: T('titel_standrohr'), text: katalogText(cfg, eintrag.scopeKey) };
    }
    return { state: 'unknown', title: T('titel_pruefen'), text: katalogText(cfg, eintrag.reasonKey) || T('text_pruefen') };
  }

  function anfrageText(daten, cfg) {
    var zeilen = [fuellen(T('anfrage_gruss'), { stand: cfg.standName })];
    if (daten.marke) zeilen.push(T('anfrage_marke') + daten.marke);
    if (daten.modell) zeilen.push(T('anfrage_modell') + daten.modell);
    if (daten.detail && daten.detail.trim()) zeilen.push(T('anfrage_detail') + daten.detail.trim());
    if (daten.nurRohr) {
      zeilen.push(T('anfrage_rohr'));
      if (daten.durchmesser && daten.durchmesser.trim()) zeilen.push(T('anfrage_durchmesser') + daten.durchmesser.trim());
    }
    var masse = daten.masse;
    if (masse && masse.some(function (v) { return String(v).trim(); })) {
      zeilen.push(T('anfrage_masse') + 'A–C ' + (masse[0] || '?') + ', A–B ' + (masse[1] || '?') + ', B–C ' + (masse[2] || '?'));
    }
    zeilen.push(daten.nurRohr ? T('anfrage_foto_rohr') : T('anfrage_foto_platte'));
    return zeilen.join('\n');
  }

  function konfigLesen(root) {
    var knoten = root.querySelector('[data-gz-config]');
    var cfg = {};
    if (knoten) { try { cfg = JSON.parse(knoten.textContent); } catch (e) { cfg = {}; } }
    cfg.maxKg = Number(cfg.maxKg) > 0 ? Number(cfg.maxKg) : 162;
    cfg.standName = cfg.standName || 'Gartenzeit-Ständer';
    cfg.whatsapp = String(cfg.whatsapp || '').replace(/[^\d]/g, '');
    cfg.mail = cfg.mail || '';
    cfg.mailBetreff = cfg.mailBetreff || 'Passform meines Ampelschirms';
    cfg.lochbilder = (cfg.lochbilder || []).filter(function (p) { return p && p.diagonale > 0 && p.seite > 0; });
    /* Shopify maskiert die Ausgabe von | t (z. B. ' als &#39;). Da die Texte hier
       per textContent gesetzt werden, muessen die Entities zurueckverwandelt werden. */
    TEXTE = entpackeAlle(cfg.texte);
    cfg.katalogTexte = entpackeAlle(cfg.katalogTexte);
    return cfg;
  }

  function aufbauen(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var cfg = konfigLesen(root);
    var q = function (s) { return root.querySelector(s); };
    var marke = q('[data-brand]'), modell = q('[data-model]');
    var detail = q('[data-detail]'), ergebnis = q('[data-result]');
    var frage = q('[data-question]');
    var aktuelleMarke, aktuellerEintrag, KATALOG = [];
    var waLink = cfg.whatsapp ? 'https://wa.me/' + cfg.whatsapp + '?text=' : '';

    var masse = function () {
      return Array.prototype.map.call(root.querySelectorAll('[data-mm]'), function (el) { return el.value; });
    };
    var leeren = function (select, ersterEintrag) { select.replaceChildren(new Option(ersterEintrag, '')); };

    function nachricht(mitMassen) {
      return anfrageText({
        marke: (aktuelleMarke && aktuelleMarke.name) || '',
        modell: labelVon(aktuellerEintrag),
        detail: detail.value,
        masse: mitMassen ? masse() : null,
        nurRohr: q('[data-tube]').checked,
        durchmesser: q('[data-diameter]').value
      }, cfg);
    }

    function linksAktualisieren() {
      var text = nachricht(false);
      var wa = q('[data-whatsapp]'), mail = q('[data-mail]'), waMass = q('[data-measure-whatsapp]');
      if (waLink) {
        wa.href = waLink + encodeURIComponent(text);
        waMass.href = waLink + encodeURIComponent(nachricht(true));
      } else {
        wa.hidden = true;
        waMass.hidden = true;
      }
      if (cfg.mail) {
        mail.href = 'mailto:' + cfg.mail + '?subject=' + encodeURIComponent(cfg.mailBetreff) + '&body=' + encodeURIComponent(text);
      } else {
        mail.hidden = true;
      }
    }

    function zeichnen() {
      var nurRohr = q('[data-tube]').checked;
      var antwort = modellBewerten(aktuellerEintrag, nurRohr, cfg);
      ergebnis.dataset.state = antwort.state;
      q('[data-symbol]').textContent = SYMBOLE[antwort.state] || '?';
      q('[data-title]').textContent = antwort.title;
      q('[data-answer]').textContent = antwort.text;
      q('[data-chosen]').textContent = aktuellerEintrag ? (aktuelleMarke.name + ' · ' + labelVon(aktuellerEintrag)) : '';
      q('[data-chosen]').hidden = !aktuellerEintrag;
      q('[data-mounting]').hidden = ['direct', 'adapter', 'geometry'].indexOf(antwort.state) === -1;

      var adapterBox = q('[data-adapter]');
      adapterBox.hidden = !antwort.adapter;
      if (antwort.adapter) {
        var ad = antwort.adapter;
        q('[data-adapter-name]').textContent = ad.name || '';
        q('[data-adapter-description]').textContent = ad.description || '';
        q('[data-adapter-maker]').href = ad.url || '#';
        var shopLink = q('[data-adapter-shop]');
        shopLink.hidden = !ad.shop;
        if (ad.shop) shopLink.href = ad.shop;
        var bild = q('[data-adapter-image]');
        var quelle = cfg.adapterBild || ad.image;
        if (quelle) {
          bild.hidden = false;
          adapterBox.classList.remove('gz-no-image');
          bild.alt = ad.name || '';
          bild.onerror = function () { bild.hidden = true; adapterBox.classList.add('gz-no-image'); };
          bild.src = quelle;
        } else {
          bild.hidden = true;
          adapterBox.classList.add('gz-no-image');
        }
      }

      q('[data-screws]').textContent = antwort.state === 'adapter' ? T('schrauben_adapter') : T('schrauben_standard');
      q('[data-filling]').textContent = fuellen(T('befuellung'), { max: cfg.maxKg });

      frage.hidden = ['unknown', 'not_direct', 'standpipe', 'geometry'].indexOf(antwort.state) === -1;
      q('[data-diameter-field]').hidden = !nurRohr;
      q('[data-question-copy]').textContent = nurRohr ? T('frage_rohr') : T('frage_standard');
      q('[data-whatsapp]').textContent = nurRohr ? T('cta_rohr') : T('cta_standard');

      var messBereich = q('[data-measure-section]');
      if (messBereich) {
        messBereich.hidden = nurRohr || antwort.state === 'unsuitable';
        if (nurRohr) {
          q('[data-measure-result]').hidden = true;
          q('[data-measure-contact]').hidden = true;
        }
      }
      q('[data-result-question]').hidden = ['direct', 'adapter'].indexOf(antwort.state) === -1;
      linksAktualisieren();
    }

    leeren(marke, T('marke_waehlen'));
    marke.disabled = true;
    var ladehinweis = q('[data-loading]');

    marke.addEventListener('change', function () {
      aktuelleMarke = KATALOG.filter(function (b) { return b.id === marke.value; })[0];
      aktuellerEintrag = undefined;
      detail.value = '';
      leeren(modell, T('modell_waehlen'));
      modell.disabled = !aktuelleMarke;
      if (aktuelleMarke) {
        aktuelleMarke.models.forEach(function (eintrag) { modell.add(new Option(labelVon(eintrag), eintrag.id)); });
        if (aktuelleMarke.coversAllModels) {
          aktuellerEintrag = aktuelleMarke.models[0];
          modell.value = aktuellerEintrag.id;
          modell.disabled = true;
        } else {
          modell.add(new Option(T('anderes_modell'), '__other'));
        }
      } else if (marke.value === '__other') {
        aktuelleMarke = { name: T('andere_marke_name') };
        aktuellerEintrag = { label: T('modell_offen'), status: 'unknown' };
      }
      zeichnen();
    });

    modell.addEventListener('change', function () {
      aktuellerEintrag = aktuelleMarke && aktuelleMarke.models
        ? aktuelleMarke.models.filter(function (e) { return e.id === modell.value; })[0]
        : undefined;
      if (modell.value === '__other') aktuellerEintrag = { label: T('anderes_modell_name'), status: 'unknown' };
      detail.value = '';
      zeichnen();
    });

    var frageZeigen = function () {
      frage.hidden = false;
      linksAktualisieren();
      detail.focus();
    };
    q('[data-model-missing]').addEventListener('click', frageZeigen);
    q('[data-result-question]').addEventListener('click', frageZeigen);
    detail.addEventListener('input', linksAktualisieren);
    q('[data-diameter]').addEventListener('input', linksAktualisieren);
    q('[data-tube]').addEventListener('change', zeichnen);

    root.querySelectorAll('[data-mm]').forEach(function (feld) {
      feld.addEventListener('input', function () {
        q('[data-measure-result]').hidden = true;
        q('[data-measure-contact]').hidden = true;
        linksAktualisieren();
      });
    });

    var messFormular = q('[data-measure-form]');
    if (messFormular) {
      messFormular.addEventListener('submit', function (event) {
        event.preventDefault();
        var antwort = masseBewerten(masse(), cfg.lochbilder);
        q('[data-measure-title]').textContent = antwort.title;
        q('[data-measure-answer]').textContent = antwort.text;
        q('[data-measure-result]').hidden = false;
        q('[data-measure-contact]').hidden = antwort.state === 'input';
        linksAktualisieren();
      });
    }

    zeichnen();

    katalogLaden(cfg.katalogUrl).then(function (marken) {
      KATALOG = marken;
      marken.forEach(function (eintrag) { marke.add(new Option(eintrag.name, eintrag.id)); });
      marke.add(new Option(T('andere_marke'), '__other'));
      marke.disabled = false;
      if (ladehinweis) ladehinweis.hidden = true;
    }).catch(function () {
      if (ladehinweis) {
        ladehinweis.hidden = false;
        ladehinweis.textContent = T('ladefehler');
      }
      marke.disabled = false;
      marke.add(new Option(T('andere_marke'), '__other'));
    });
  }

  function starten(bereich) {
    bereich.querySelectorAll('[data-gz-finder]').forEach(aufbauen);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { starten(document); });
  } else {
    starten(document);
  }
  if (!window.__gzFinderSectionListener) {
    window.__gzFinderSectionListener = true;
    document.addEventListener('shopify:section:load', function (event) { starten(event.target); });
  }
})();
